import React, { ReactElement } from 'react'
import { FieldType } from './utils/fieldTypeEnum'
import { CvrLookup } from './Fields/CvrLookup/CvrLookup'
import { InputFieldBase } from './Fields/types'
import { TextInput } from './Fields/TextInput/TextInput'
import { Divider } from './Fields/Divider/Divider'
import { AddressLookup } from './Fields/AddressLookup/AddressLookup'
import { DateInput } from './Fields/Datepicker/DatePicker'
import { TimeInput } from './Fields/Timepicker/Timepicker'
import { AccountNumber } from './Fields/AccountNumber/AccountNumber'
import { Select, SelectProps } from './Fields/Select/Select'
import { Checkbox } from './Fields/Checkbox/Checkbox'
import { CheckboxGroup, CheckboxGroupProps } from './Fields/CheckboxGroup/CheckboxGroup'
import { Switch } from './Fields/Switch/Switch'
import { PhoneNumber } from './Fields/PhoneNumber/PhoneNumber'
import { FileUpload } from './Fields/FileUpload/FileUpload'

export type FormFieldProps = InputFieldBase & {
  optionalLabel?: string
}

export default function FormField({ optionalLabel = '(valgfri)', ...field }: FormFieldProps): ReactElement {
  //add (valgfri) to label if field is optional
  const { required, label } = field

  let displayLabel = label
  //Fields such as Switch and Checkbox are exceptions to the optionalLabel
  if (!required && optionalLabel) {
    if (field.fieldType !== FieldType.SWITCH && field.fieldType !== FieldType.CHECKBOX) {
      displayLabel = `${label} ${optionalLabel}`
    }
  }
  field.label = displayLabel

  const fieldMap = new Map<FieldType, ReactElement>([
    [FieldType.ACCOUNTNUMBER, <AccountNumber mask="*** *** *** *** ***" type="text" key={field.id} {...field} />],
    [FieldType.FAKTURA_KONTONUMMER, <AccountNumber mask="*** *** *** *** ***" type="text" key={field.id} {...field} />],
    [FieldType.CVR, <CvrLookup key={field.id} {...field} />],
    [FieldType.ADDRESS, <AddressLookup key={field.id} {...field} />],
    [FieldType.NAME, <TextInput type="text" key={field.id} {...field} />],
    [FieldType.TEXT, <TextInput type="text" key={field.id} {...field} />],
    [FieldType.NUMBER, <TextInput type="tel" key={field.id} {...field} />],
    [FieldType.PASSWORD, <TextInput type="password" key={field.id} {...field} />],
    [FieldType.MESSAGE, <TextInput key={field.id} {...field} />],
    [FieldType.EMAIL, <TextInput type="email" key={field.id} {...field} />],
    [FieldType.INVOICENUMBER, <TextInput type="number" key={field.id} {...field} />],
    [FieldType.DIVIDER, <Divider key={field.id} {...field} />],
    [FieldType.DATEPICKER, <DateInput key={field.id} {...field} />],
    [FieldType.TIMEPICKER, <TimeInput key={field.id} {...field} />],
    [FieldType.SELECT, <Select key={field.id} {...(field as SelectProps)} />],
    [FieldType.SWITCH, <Switch key={field.id} {...field} />],
    [FieldType.CHECKBOX, <Checkbox key={field.id} {...field} />],
    [FieldType.CHECKBOXGROUP, <CheckboxGroup key={field.id} {...(field as CheckboxGroupProps)} />],
    [FieldType.PHONE_DK, <PhoneNumber mask="** ** ** ** ** ** ** **" type="tel" key={field.id} {...field} />],
    [FieldType.PHONE_INTERNATIONAL, <PhoneNumber type="tel" key={field.id} {...field} />],
    [FieldType.FILEUPLOAD, <FileUpload key={field.id} type="file" {...field} />],
  ])

  return fieldMap.get(field.fieldType!) || <></>
}
